module.exports = __webpack_public_path__ + "assets/assets/images/home/dentists-page-4.25f9b886.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/home/dentists-page-4.svg
// module id = 217
// module chunks = 0